import { Dropdown, Menu } from 'antd';
import styled from 'styled-components';


const StyledPrimaryButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    padding: 0px 21px;
    border: none;
    background: ${({type}) => type === "link" ? "transparent" : type === "danger" ? "var(--sp-error-hover-color)" : "var(--sp-main-color)"};
    font-size: 14px;
    line-height: 20px;
    white-space: nowrap;
    color: ${({type}) => type === "link" ? "var(--sp-main-color)" : "#FFFFFF"};
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        background: ${({type}) => type === "link" ? "#DBE9FF" : type === "danger" ? "#FF4E4E" : "var(--sp-main-color-hover)"};
    }

    &:focus {
        outline: none;
        box-shadow: 0 0 0 2px rgba(35, 120, 255, 0.2);
        background: ${({type}) => type === "link" && "#DBE9FF"};
    }

    &:active > span {
        transform: translateY(1px);
    }

    & > span:not(:last-child) {
        margin-right: 8px;
    }

    &[disabled] {
        background: var(--sp-disabled-color);
        cursor: not-allowed;
    }

    &[disabled] span {
        color: rgba(50, 97, 175, .5);
        opacity: 0.8;
        fill-opacity: 0.8;
    }
`;

const Button = (props) => {
    return (
        <StyledPrimaryButton {...props}>
            {Array.isArray(props.children)
            ? props.children.map((child, idx) => <span key={`btn-text-${idx}`}>{child}</span>)
            : <span>{props.children}</span>}
        </StyledPrimaryButton>
    )
};

export { Button };

const StyledTextButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    padding: 0;
    background: transparent;
    font-size: 14px;
    line-height: 20px;
    white-space: nowrap;
    color: ${({danger}) => danger ? "var(--sp-danger-color)" : "var(--sp-main-color-hover)"};
    cursor: pointer;
    transition: all 0.3s ease;
    max-width: ${({ maxWidth }) => maxWidth};

    & span {
        overflow: ${({maxWidth}) => maxWidth && "hidden"};
        text-overflow: ${({maxWidth}) => maxWidth && "ellipsis"};
    }

    &:hover {
        color: ${({danger}) => danger ? "var(--sp-danger-hover-color)" : "var(--sp-main-color)"};
    }

    &:focus {
        outline: none;
    }

    &:active > span {
        transform: translateY(1px);
    }

    & > span:not(:last-child) {
        margin-right: 8px;
    }

    &[disabled] {
        cursor: not-allowed;
    }

    &[disabled] span {
        color: var(--sp-disabled-text-color);
    }
`;

export const TextButton = (props) => (
    <StyledTextButton {...props}>
            {Array.isArray(props.children)
            ? props.children.map((child, idx) => <span key={`btn-text-${idx}`}>{child}</span>)
            : <span>{props.children}</span>}
    </StyledTextButton>
);

export const DropdownButton = ({ items=[], onMenuClick, ...props }) => {
    const menu = (
        <Menu onClick={onMenuClick}>
            {items.map(item => (
                <Menu.Item
                    key={item.key}
                >
                    {item.title}
                </Menu.Item>
            ))}
        </Menu>
    );

    return(
        <Dropdown overlay={menu} trigger={["click"]} placement="topLeft">
            <StyledPrimaryButton>
                {props.children}
            </StyledPrimaryButton>
        </Dropdown>
    )
};